<template>
  <div class="sidebar">
    <div class="sidebar-EL-Img-Box">
      <el-image class="EL-Image" :src="require('@/assets/logo.png')"></el-image>
      <div class="WMS">斯凯孚(常山)WMS系统</div>
    </div>
    <div class="overflow-box">
      <div class="noScrollBox noScroll">
        <el-menu
          :unique-opened="true"
          :default-active="pageName"
          router
          :collapse="isCollapse"
        >
          <div v-for="item in menu" :key="item.name">
            <el-menu-item
              :class="item.children[0].name === $route.name ? 'active' : ''"
              v-if="!item.name"
              :index="item.children[0].name"
            >
              <i :class="item.children[0].meta.icon"></i>
              <span slot="title">{{ item.children[0].meta.title }}</span>
            </el-menu-item>
            <el-submenu
              :index="item.name"
              v-if="item.children && item.children.length > 1"
              v-authority="item.meta ? item.meta.role : ''"
            >
              <template slot="title">
                <i v-if="item.meta" :class="item.meta.icon || ''" />
                <span slot="title">{{
                  item.meta ? item.meta.title : item.name
                }}</span>
              </template>
              <!-- @click="jump(child)" -->
              <el-menu-item
                :class="child.name === $route.name ? 'active' : ''"
                v-for="child in item.children"
                :key="child.name"
                v-authority="child.meta ? child.meta.role : ''"
                :index="child.path"
                >{{ child.meta.title || item.name }}&nbsp;<el-badge v-if="child.meta.title == '领用审批' || item.name == '领用审批'" :value="examineDataCount" class="item">
						</el-badge></el-menu-item
              >
            </el-submenu>
          </div>
        </el-menu>
      </div>
    </div>
  </div>
</template>

<script>
import { mapMutations } from "vuex";
import siblingCall from "@/libs/siblingCall";
export default {
  name: "Sidebar",
  data() {
    return {
      routes: [],
      isCollapse: false,
      pageName: "",
      breadcrumb: [],
      menu: [],
      userAccount: "",
      userId: "",
      examineDataCount:"",
    };
  },
  created() {
    this.setMenu();
  },
  watch: {
    $route: function () {
      this.pageName = this.$route.name;
      this.breadcrumb = this.$route.matched;
      this.$store.commit("setTags", this.$route);
    },
  },
  methods: {
    // ...mapMutations(["setTags"]),
    // jump(item) {
      // console.log(item.name);
      // console.log(item.path);
      // console.log(item.meta.title);
    //   this.setTags({
    //     title: item.meta.title,
    //     path: item.path,
    //   });
    // },

    setMenu() {
        const routes = this.deepCopy(this.$router.options.routes);
        this.menu = this.routerFilter(routes);
    },
    //过滤器
    routerFilter(routes) {
        routes = routes.filter(item => {
            if (item.hidden && item.path != '/') return false; //过滤隐藏菜单
            if (item.children && item.children.length) {
                //递归子菜单
                item.children = this.routerFilter(item.children);
            }
            // //格式化一下，补全meta，防止憨批不写meta报错===========
            if (!item.meta) {
                item.meta = {
                    title: item.name,
                    icon: "el-icon-menu"
                };
            } else if (!item.meta.title) {
                item.meta.title = item.name;
            } else if (!item.meta.icon) {
                item.meta.icon = "el-icon-menu";
            }
            return item;
        });
        return routes;
    },

    // setMenu() {
    //   this.menu = this.deepCopy(this.$router.options.routes);
    // },

    //查询领用申请数量
    getApplyExamineCount(){
      this.$http
        .request({
          url: "/api/auxiMaterial/getExamineAuxi",
          method: "GET",
          params: {
            pageNum: 1,
            pageSize: 999999,
            person: localStorage.getItem("empNumber") || "",
          },
        })
        .then((resp) => {
          if (resp.status == 100) {
            this.examineDataCount = resp.data.total;
          }
        })
        .catch((error) => {
          this.$message({
            message: "操作失败",
            type: "warning",
          });
        });
    },
  },
  mounted() {
    this.userAccount = localStorage.getItem("user");
    this.userId = localStorage.getItem("id");
    this.$store.commit("setTags", this.$route);
    this.breadcrumb = this.$route.matched;
    this.pageName = this.$route.name;
    this.setMenu();
    this.getApplyExamineCount();
    siblingCall.$on("TriggerGetMsgNum",(TriggerGetMsgPara) => {
      this.getApplyExamineCount();
    })
    // if (this.userAccount != "admin") {
    //     this.passDay();
    // }
    // console.log("menu", this.menu);
  },
};
</script>
<style lang="scss" scoped>
@import "../../style/variables.scss";

.sidebar {
  width: 160px;
  min-width: 150px;
  flex-shrink: 0;
  background-color: $sidebarbg;
  position: relative;
  font-size: 0.7rem;
  .sidebar-EL-Img-Box {
    // height: 1000px !important;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    // justify-content: center;
    color: rgb(234, 244, 254);
    // padding-bottom: 10px;
    // border-bottom: 1px solid white;
    .EL-Image {
      width: 60%;
    }
    .WMS {
      margin-top: 2px;
      font-size: 13px;
      text-indent: 0.5rem;
    }
  }
}

.back-btn {
  width: 60px;
  height: 60px;
  color: $menutext;
  font-size: 0.7rem;
  border-radius: 50%;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background-color: #00549e;
  position: absolute;
  bottom: 20px;
  left: 50%;
  transition: 0.2s all;
  transform: translateX(-50%);
  box-shadow: 0px 3px 6px 0px rgba(0, 0, 0, 0.16);

  &:hover {
    background-color: #0c68b8;
  }
}

.overflow-box {
  width: 160px;
  overflow: hidden;
}

.noScrollBox {
  width: 113%;
  height: 100vh;
  overflow-y: scroll;
  padding-bottom: 50px;
  div {
    li {
      margin: 0 !important;
      font-size: 0.7rem;
    }
  }
}
</style>

<style>
/* .el-menu-item{
  padding: 0 !important;
} */
.el-submenu__title {
  z-index: 10;
  padding: 0 !important;
  padding-left: 10px !important;
  margin: 0 !important;
  /* margin-right: 10px !important; */
}
.el-submenu__icon-arrow {
  margin-right: 5px !important;
}
</style>